<template>
  <div class="CopyInput">
    <div class="container position-relative text-center">
        <input type="text" id="page-link" :value="baseUrl + $route.fullPath + '?cs=4'" class="form-control mt-3" >
        <button aria-label="کپی" class="btn btn-info button share-button my-3" @click="copy">کپی</button>
        <router-link to="/epay" class="btn btn-info button my-3"> صفحه ساخت فاکتور</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CopyInput',
  data () {
    return {
      baseUrl: 'https://nuorashop.ir'
    }
  },
  methods: {
    copy: function () {
      const copyText = document.getElementById('page-link')
      copyText.select()
      navigator.clipboard.writeText(copyText.value)
      this.fire({
        position: 'center',
        icon: 'success',
        title: 'کپی شد',
        showConfirmButton: false,
        timer: 1500
      })
    }
  }
}
</script>

<style scoped>
.share-button{
  position: absolute;
  top: -16px;
  right: 12px;
}
.btn{
  border-radius: .25rem;
}
input{
  direction: ltr;
}
</style>
